import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWebhook = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.4 16.4033H12.009C11.019 16.4033 10.254 17.2443 9.777 18.1032C9.39941 18.8076 8.79581 19.3662 8.06216 19.6904C7.32851 20.0146 6.50691 20.0856 5.72796 19.8923C4.94902 19.699 4.25744 19.2523 3.76315 18.6234C3.26887 17.9945 3.00025 17.2193 3 16.4212C3.009 15.7949 3.18 15.1686 3.513 14.6318M6.6 16.4212L9.417 11.2498C9.894 10.3819 9.507 9.29932 8.967 8.47619C8.71213 8.07098 8.54148 7.61913 8.46512 7.1473C8.38876 6.67546 8.40823 6.1932 8.52239 5.72897C8.63655 5.26474 8.84308 4.82794 9.1298 4.44434C9.41651 4.06074 9.77761 3.73811 10.1918 3.49549C10.606 3.25288 11.0648 3.09518 11.5413 3.03171C12.0178 2.96823 12.5022 3.00027 12.966 3.12593C13.4298 3.25159 13.8636 3.46833 14.2418 3.76335C14.62 4.05838 14.9349 4.42571 15.168 4.84369M12 6.57942L14.817 11.7061C15.294 12.5739 16.41 12.8424 17.4 12.8424C18.3548 12.8424 19.2705 13.2194 19.9456 13.8906C20.6207 14.5617 21 15.472 21 16.4212C21 17.3703 20.6207 18.2806 19.9456 18.9518C19.2705 19.6229 18.3548 20 17.4 20",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgWebhook);
export { ForwardRef as ReactComponent };
